// import components
import Gate from '@/components/reports/Gate'
import Utilization from '@/components/reports/Utilization'
import Financial from '@/components/reports/Financial'
import InvoiceSource from '@/components/reports/InvoiceSource'
import Generate from '@/components/reports/Generate'
import Error from '@/components/reports/Error'

export default [
  {
    path: 'gate',
    component: Gate
  },
  {
    path: 'utilization',
    component: Utilization
  },
  {
    path: 'financial',
    component: Financial
  },
  {
    path: 'invoiceSource',
    component: InvoiceSource
  },
  {
    path: 'generate',
    component: Generate
  },
  {
    path: 'error',
    component: Error
  }
]
